module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAAFQMh/AAAAAXNSR0IArs4c6QAAAHlJREFUWEftlssJgDAQRF+6UDvSNgS7sg2tyE8ZEnBP4nGSQyYF7GMfm2ESlV6qxKVd8AisQC9WfwEzsIfqswA0dsrwoQb4zksGeHpVd2LVB7AAW7tXLTb8HW/VxZSHaieXUrmTS2nXAYI7lzuX5Is5uSRaf4e2V30ebEYeIW9UJjMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/client/clientplaylist/client-menu-playlist.png
// module id = 1135
// module chunks = 110